import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white stats-item" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 pt-lg-30 letter-spacing" };
const _hoisted_3 = { class: "row justify-content-between" };
const _hoisted_4 = { class: "col-xxxl-12" };
const _hoisted_5 = { class: "row" };
const _hoisted_6 = { class: "col-md-6 mb-4" };
const _hoisted_7 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_8 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_9 = { class: "col-md-6 mb-4" };
const _hoisted_10 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_11 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_12 = { class: "row" };
const _hoisted_13 = { class: "col-md-6 mb-4" };
const _hoisted_14 = { class: "form-group position-relative transition mt-2" };
const _hoisted_15 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_16 = { class: "col-md-6 mb-4" };
const _hoisted_17 = { class: "form-group position-relative transition mt-2" };
const _hoisted_18 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_19 = { class: "row" };
const _hoisted_20 = { class: "col-md-6 mb-4" };
const _hoisted_21 = { class: "form-group position-relative transition mt-2" };
const _hoisted_22 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_23 = { class: "col-md-6 mb-4" };
const _hoisted_24 = { class: "form-group position-relative transition mt-2" };
const _hoisted_25 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_26 = { class: "col-lg-4 col-md-4 d-flex flex-column align-items-center justify-content-center text-center mb-4 mb-lg-0" };
const _hoisted_27 = {
    class: "fw-bold text-black",
    style: { "font-size": "22px" }
};
const _hoisted_28 = { class: "col-lg-5 col-md-4" };
const _hoisted_29 = {
    key: 0,
    id: "nombreCommandeProductChart",
    class: "chart"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    const _component_apexchart = _resolveComponent("apexchart");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", null, [
                                _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('forms.start')), 1),
                                _withDirectives(_createElementVNode("input", {
                                    type: "date",
                                    class: "form-control shadow-none rounded-0 text-black mb-3",
                                    placeholder: "e.g. 2025-05-01",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.localStartDate) = $event)),
                                    onChange: _cache[1] || (_cache[1] = (event) => _ctx.handleInput(event, 'startDate'))
                                }, null, 544), [
                                    [_vModelText, _ctx.localStartDate]
                                ]),
                                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('forms.startTime') || 'Heure de début'), 1),
                                _withDirectives(_createElementVNode("input", {
                                    type: "time",
                                    class: "form-control shadow-none rounded-0 text-black",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.startTime) = $event)),
                                    onChange: _cache[3] || (_cache[3] = ($event) => (_ctx.handleTimeChange('startTime')))
                                }, null, 544), [
                                    [_vModelText, _ctx.startTime]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", null, [
                                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('forms.end')), 1),
                                _withDirectives(_createElementVNode("input", {
                                    type: "date",
                                    class: "form-control shadow-none rounded-0 text-black mb-3",
                                    placeholder: "e.g. 2025-05-01",
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.localEndDate) = $event)),
                                    onChange: _cache[5] || (_cache[5] = (event) => _ctx.handleInput(event, 'endDate'))
                                }, null, 544), [
                                    [_vModelText, _ctx.localEndDate]
                                ]),
                                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('forms.endTime') || 'Heure de fin'), 1),
                                _withDirectives(_createElementVNode("input", {
                                    type: "time",
                                    class: "form-control shadow-none rounded-0 text-black",
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.endTime) = $event)),
                                    onChange: _cache[7] || (_cache[7] = ($event) => (_ctx.handleTimeChange('endTime')))
                                }, null, 544), [
                                    [_vModelText, _ctx.endTime]
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('forms.category')), 1),
                                _createVNode(_component_v_select, {
                                    modelValue: _ctx.categorieSelected,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.categorieSelected) = $event)),
                                    options: _ctx.originalCategories,
                                    label: "name",
                                    reduce: (categorie) => categorie.id,
                                    placeholder: _ctx.$t('forms.category')
                                }, null, 8, ["modelValue", "options", "reduce", "placeholder"])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('forms.product')), 1),
                                _createVNode(_component_v_select, {
                                    modelValue: _ctx.productSelected,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.productSelected) = $event)),
                                    options: _ctx.originalProducts,
                                    label: "name",
                                    reduce: (product) => product.id,
                                    placeholder: _ctx.$t('forms.product')
                                }, null, 8, ["modelValue", "options", "reduce", "placeholder"])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('forms.orderType')), 1),
                                _createVNode(_component_v_select, {
                                    modelValue: _ctx.orderTypeSelected,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.orderTypeSelected) = $event)),
                                    options: _ctx.listeOrderType,
                                    label: "libelle",
                                    reduce: (orderType) => orderType.type,
                                    placeholder: _ctx.$t('forms.orderType')
                                }, null, 8, ["modelValue", "options", "reduce", "placeholder"])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('order.paymentMethod')), 1),
                                _createVNode(_component_v_select, {
                                    modelValue: _ctx.methodePaiementSelected,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.methodePaiementSelected) = $event)),
                                    options: _ctx.listeMethode,
                                    label: "libelle",
                                    reduce: (methode) => methode.type,
                                    placeholder: _ctx.$t('order.paymentMethod')
                                }, null, 8, ["modelValue", "options", "reduce", "placeholder"])
                            ])
                        ])
                    ])
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-lg-3 col-md-4 d-flex align-items-center justify-content-center mb-4 mb-lg-0" }, [
                    _createElementVNode("div", {
                        class: "stats-icon rounded-circle d-flex align-items-center justify-content-center",
                        style: { "width": "90px", "height": "90px", "background": "rgba(3, 143, 50, 0.12)" }
                    }, [
                        _createElementVNode("i", {
                            class: "flaticon-sterile-box text-success",
                            style: { "font-size": "34px" }
                        })
                    ])
                ], -1)),
                _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("span", _hoisted_27, [
                        _createTextVNode(_toDisplayString(_ctx.formattedTotalAmount) + " ", 1),
                        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-muted small" }, "CHF", -1))
                    ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                    (_ctx.answered && _ctx.answeredTicketsChart && _ctx.chartReady)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            (_openBlock(), _createBlock(_component_apexchart, {
                                key: _ctx.chartKey,
                                type: "area",
                                height: "120",
                                options: _ctx.answeredTicketsChart,
                                series: _ctx.answered
                            }, null, 8, ["options", "series"]))
                        ]))
                        : _createCommentVNode("", true)
                ])
            ])
        ])
    ]));
}
